var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company"},[_c('div',{attrs:{"id":"join"}},[_c('Join')],1),_c('ContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }